import React, { memo, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mafc/trolly';

import { getFormattedPrice, IFinalPrice, IPrice } from 'utils/price.util';
import SummaryRowTypes from './row.types';

import * as S from './OrderSummaryRow.style';

interface Props {
  label: ReactNode | string;
  isDiscount?: boolean;
  priceDetails?: IPrice | IFinalPrice;
  shouldShowFree?: boolean;
  testId?: string;
  variant?: SummaryRowTypes;
  className?: string;
}

const OrderSummaryRow: React.FC<Props> = props => {
  const {
    testId,
    label,
    priceDetails,
    variant,
    isDiscount,
    shouldShowFree,
    className = '',
  } = props;
  const { t } = useTranslation();

  let price = '';
  const showFreeForZeroValue = priceDetails && priceDetails.value === 0 && shouldShowFree;
  if (showFreeForZeroValue) {
    price = t('free');
  } else if (priceDetails) {
    price = getFormattedPrice(priceDetails, false, true, true);
  }

  return (
    <S.OrderSummaryRow variant={variant} className={className}>
      <Box as="span">{label}</Box>

      <Box as="span" data-test={`__order_summary_${testId}_price__`}>
        {isDiscount && <S.MinusSign as="span">-</S.MinusSign>}
        {price}
      </Box>
    </S.OrderSummaryRow>
  );
};

OrderSummaryRow.defaultProps = {
  testId: '',
  variant: SummaryRowTypes.default,
};

export default memo(OrderSummaryRow);
